














/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getDispatchersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_DISPATCHERS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getDispatcherDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_DISPATCHER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addDispatcher: (data) => {
    return axios.post(API_ENDPOINTS.ADD_DISPATCHER, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  updateDispatcher: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DISPATCHER_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteDispatcher: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_DISPATCHER_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getdriversandservices: (params) => {
    return axios.get(API_ENDPOINTS.GET_DRIVERS_AND_SERVICES, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
    
  },
  getselectedservicedrivers: (params) => {
    //console.log('idddd->',params);
    const { id, demoaccount_id } = params;
    const queryParams = {};
    if (demoaccount_id) {
      queryParams.demoaccount_id = demoaccount_id;
    }
    return axios.get(API_ENDPOINTS.GET_SELECTED_SERVICE_DRIVERS+ "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params: queryParams,
    });
  },
  getselectedridestatus: (params) => {
    //console.log('data->',params);
    return axios.get(API_ENDPOINTS.GET_SELECTED_RIDE_STATUS_DRIVERS, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params
    });
  },
  createridebydispatcher: (data) => {
  //  console.log('createride-->',data)
    return axios.post(API_ENDPOINTS.CREATE_NEW_RIDE_BY_DISPATCHER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  createpackagelogisticstripbydispatcher: (data) => {
    return axios.post(API_ENDPOINTS.CREATE_PACKAGE_LOGISTICS_TRIP_BY_DISPATCHER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  assignridebydispatcher: (data) => {
    return axios.post(API_ENDPOINTS.ASSIGN_NEW_RIDE_BY_DISPATCHER, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  },
  fetchnearbydrivers: (data) => {
    let url = `${API_ENDPOINTS.FETCH_NEARBY_DRIVERS}`;
    return axios.post(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
      },
    });
  }, 
};
